/* eslint-disable no-console */
import { action, makeAutoObservable } from 'mobx'

import type {
  CsatScore,
  RemoteTicketId,
  Ticket,
  TicketId,
} from '@server/models/ticket/ticket.dto'

import type { SyncService } from './sync'

export type TicketData = Pick<
  Ticket,
  'id' | 'csatScore' | 'remoteId' | 'title' | 'csatDidThatHelp'
>

/**
 * Store for a single ticket.
 */
export class TicketStore {
  id: TicketId
  remoteId?: RemoteTicketId
  title?: string
  csatScore?: CsatScore
  csatDidThatHelp?: boolean
  syncStore: SyncService
  isReadOnly = false

  constructor(
    ticket: TicketData,
    syncStore: SyncService,
    isReadOnly: boolean = false,
  ) {
    makeAutoObservable(this, {
      syncStore: false,
    })
    this.id = ticket.id
    this.csatDidThatHelp = ticket.csatDidThatHelp
    this.remoteId = ticket.remoteId
    this.csatScore = ticket.csatScore
    this.title = ticket.title
    this.syncStore = syncStore
    this.isReadOnly = isReadOnly
  }

  @action
  update(data: Partial<Ticket>) {
    console.log(`Updating ticket ${this.id} with`, data)
    this.syncStore.events.push({
      model: 'ticket',
      action: 'update',
      data: {
        id: this.id,
        ...data,
      },
    })

    // stub for now
    if (data.csatScore !== undefined) {
      this.csatScore = data.csatScore
    }
    if (data.title) {
      this.title = data.title
    }

    if (data.csatDidThatHelp !== undefined) {
      this.csatDidThatHelp = data.csatDidThatHelp
    }
  }
}
